import { TextField } from '@mui/material'
import React from 'react'
import { NavLink } from 'react-router-dom'
import MaterialSymbol from '../icons/material-symbol';

type Props = {
  profileImage: string;
  searchValue: string;
  handleSearch: (e: any) => void;
  clearSearchHandler: (e: any) => void;
  clearSearch: boolean;
  handleSearchInputShow?: (e: any) => void;
  handleFilterPopup?: (e: any) => void;
}

const InfluencerMobileHeader = ({ clearSearch, profileImage, searchValue, handleSearch, clearSearchHandler, handleFilterPopup }: Props) => {
  return (
    <section className='fixed-header'>
      <NavLink to="/influencer/settings">
        <span className="_header_profile_picture">
          <img
            src={profileImage}
            alt="profile"

          />

        </span>
      </NavLink>
      <div className='search-sec search-sec-mobile d-md-none'>
        <>
          <TextField
            className='input-login search-plan-input w-100'
            variant='outlined'
            label='Search'
            size='small'
            value={searchValue}
            onChange={handleSearch}
          />
          {clearSearch && (
            <span
              className='clear-search-result d-none d-md-block'
              onClick={clearSearchHandler}
              style={{ cursor: 'pointer', color: 'blue' }}
            >
              Clear search results
            </span>
          )}
        </>
      </div>
      <div className="icons">
        {/* <button onClick={}>
          <MaterialSymbol iconName="notifications" fontweight="200" fontSize='30px'  />
        </button> */}
        <NavLink to="/influencer/campaign-msg">
          <MaterialSymbol iconName="chat" fontweight="200" fontSize='26px' />
        </NavLink>
        </div>
    </section>
  )
}

export default InfluencerMobileHeader